import { z } from 'zod';

/**
 * Chat composer dictation (POST /api/chat/dictation, multipart field `audio`).
 * The audio is proxied to the self-hosted ASR and never persisted.
 */

/** 2 minutes: a spoken prompt, not a meeting. Longer audio goes through the batch transcription flow. */
export const CHAT_DICTATION_MAX_DURATION_SECONDS = 120;

/** 4 MiB: 2 min of Safari AAC (~128 kbps) with margin; Opus at 24–32 kbps stays under 0.5 MB. */
export const CHAT_DICTATION_MAX_SIZE_BYTES = 4 * 1024 * 1024;

export const chatDictationResponseSchema = z.object({
  durationMs: z.number().int().nonnegative(),
  language: z.string().nullable(),
  text: z.string(),
});

export type ChatDictationResponseDTO = z.infer<typeof chatDictationResponseSchema>;
